import Smartphones from 'Counterparties/Suppliers/views/SupplierView/containers/Smartphones'
import Tablets from 'Counterparties/Suppliers/views/SupplierView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const SupplierView = getCurrentDeviceView(Smartphones, Tablets)

export default SupplierView
